

import React from 'react';
import { ORGANISATION_ID } from '@shootsta/common-domain-data';
import RequestProvider from '../../../RequestProvider';
import AboutAddonModalComponent from '../components/AboutAddonModal';
import { getExplanationVideoUrl as getExplanationVideoUrlQuery } from '../api';
import { ABOUT_ADDON_OPTIONS } from '../../../../common/constants';

const AboutAddonModal = (props) => {
  const { addonType } = props;

  return (
    <RequestProvider requests={{
      getExplanationVideoUrl: getExplanationVideoUrlQuery(
        ORGANISATION_ID.SHOOTSTA, ABOUT_ADDON_OPTIONS[addonType].VIDEO_NAME
      )
    }}>

      {(requests) => <AboutAddonModalComponent {...props} {...requests} />}
    </RequestProvider>);

};


export default AboutAddonModal;